// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleContent_root__2rc_g"};